import { render, staticRenderFns } from "./TakeCoursePage.vue?vue&type=template&id=30bc9678&scoped=true"
import script from "./TakeCoursePage.vue?vue&type=script&lang=js"
export * from "./TakeCoursePage.vue?vue&type=script&lang=js"
import style0 from "./TakeCoursePage.vue?vue&type=style&index=0&id=30bc9678&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bc9678",
  null
  
)

export default component.exports